import AutoRecipeForm from './AutoRecipeForm';

export default AutoRecipeForm;
